export default {"src":"/komodo/_next/static/media/eth.d5bfc7cd.svg","height":44,"width":93,"blurWidth":0,"blurHeight":0};